import * as changeCase from "change-case";
import type { ReactNode } from "react";
import { reactNodeToPlainString } from "./reactNodeToPlainString";

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * Generates a consistent test ID for form fields
 * @param name - The field name (e.g., "first_name", "organisation_name")
 * @param suffix - Optional suffix (e.g., "input", "trigger", "option")
 * @returns Kebab-case test ID (e.g., "first-name-input", "specialty-trigger")
 */
export function getTestId(name: string, suffix?: string): string {
    const kebabName = changeCase.kebabCase(name);
    return suffix ? `${kebabName}-${suffix}` : kebabName;
}

/**
 * Option testids must stay locale-stable. Prefer the canonical `value` (e.g. "Left", "Knee")
 * when it is human-readable; fall back to the label for UUID values (clinicians, methods).
 */
export function getOptionTestId(option: { value: string; label: ReactNode }): string {
    const value = String(option.value ?? "").trim();
    if (value.length > 0 && !UUID_RE.test(value)) {
        return getTestId(value, "option");
    }
    return getTestId(reactNodeToPlainString(option.label), "option");
}
